import React__default from 'react';
import './ListViewGroup.scss';

const ListViewGroup = ({ children, 'aria-label': ariaLabel, className, }) => {
    return (React__default.createElement("ul", { "data-rev-component": 'list-view-group', "aria-label": ariaLabel, className: className }, children));
};

export { ListViewGroup };
//# sourceMappingURL=ListViewGroup.js.map
